import dayjs from 'dayjs';
import { TFunction } from 'i18next';

import { Text } from '@pentabd/ui';

import { StatusBadge, ViewButton } from '@components';

import { useFunctionalityData } from '@hooks/useFunctionalityData';
import { useLanguage } from '@hooks/useLanguage';

import { FUNCTIONALITY_DATA } from '@constants/functionality-data';

const { LEAVE_TYPE } = FUNCTIONALITY_DATA;

export const TableColumn = (
  t: TFunction<'translation', undefined>,
) => {
  const { language } = useLanguage();

  const { data: leaveTypeData } = useFunctionalityData(LEAVE_TYPE);

  return [
    {
      id: 1,
      key: 'applicationDate',
      name: t('LEAVE_HISTORY.TABLE.COLUMN.DATE_OF_APPLICATION'),
      render: (applicationDate: string) => {
        return (
          <Text color="subtitle1">
            {dayjs(applicationDate).format('DD MMM, YYYY')}
          </Text>
        );
      },
    },
    {
      id: 2,
      key: 'leaveTypeId',
      name: t('LEAVE_HISTORY.TABLE.COLUMN.TYPE'),
      render: (leaveTypeId: string) => {
        const leaveType = leaveTypeData.find(
          (type: any) => type.id === leaveTypeId,
        );        

        return (
          <Text color="info" weight='semibold'>
            {language === 'bn' ? leaveType?.nameBn : leaveType?.name}
          </Text>
        );
      },
    },
    {
      id: 3,
      key: 'startDate',
      name: t('LEAVE_HISTORY.TABLE.COLUMN.FROM_DATE'),
      render: (startDate: string) => (
        <Text color="subtitle1">{dayjs(startDate).format('DD MMM, YYYY')}</Text>
      ),
    },
    {
      id: 4,
      key: 'endDate',
      name: t('LEAVE_HISTORY.TABLE.COLUMN.TO_DATE'),
      render: (endDate: string) => (
        <Text color="subtitle1">{dayjs(endDate).format('DD MMM, YYYY')}</Text>
      ),
    },
    {
      id: 5,
      key: 'leaveDaysCount',
      name: t('LEAVE_HISTORY.TABLE.COLUMN.DURATION'),
      render: (leaveDaysCount: number) => (
        <Text color="subtitle1">{`${leaveDaysCount} Day${
          leaveDaysCount > 0 ? 's' : ''
        }`}</Text>
      ),
    },
    {
      id: 6,
      key: 'status',
      name: t('LEAVE_LIST.TABLE.COLUMN.STATUS'),
      render: (status: string) => <StatusBadge status={status} />,
    },
    {
      id: 7,
      key: 'id',
      render: (id: any, row: any) => (
        <ViewButton
          link={`/leave/${row.employeeMasterId}/${id}`}
          openInNewTab
        />
      ),
    },
  ];
};
